import { render, staticRenderFns } from "./ResourcesNcfHeader.vue?vue&type=template&id=aaac4d52&"
import script from "./ResourcesNcfHeader.vue?vue&type=script&lang=js&"
export * from "./ResourcesNcfHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports